import request from "@/service/request";
import qs from "qs";
import { projectCode } from "@/lib/utils/dictionary";

// 获取名额海报数据
export const getListGroupPosterApi = (data) => {
  // let url = '/productpage/keti/listGroupByTypeV2'
  //
  // // 1v1课题
  // if (projectCode.oneVipProjectCode.includes(params.standardCode)) {
  //   url = '/productpage/keti/listGroupByType'
  // }

  return request({
    url: "/pubController/pageForPosterV2",
    method: "post",
    data,
  });
};

// 获取名额海报时间
export const getListGroupPosterTimeApi = (params) => {
  return request({
    url: "/productpage/keti/getPosterCourseTime",
    method: "get",
    params,
  });
};

// 获取课题列表数据
export const getListApi = (data) => {
  let url = "/pubController/pageV2";
  if (data.pathUrl == "Lists") {
    url = "/pubController/aisCisPage";
    data.h5Type = 0;
    delete data.courseCategory;

    // debugger
    if (data.coursePackageCodeList && data.coursePackageCodeList.length >= 12) {
      delete data.coursePackageCodeList;
      delete data.productPackageCodeList;
    }
  }
  // 1v1课题
  // if (projectCode.oneVipProjectCode.includes(params.standardCode)) {
  //   url = '/productpage/keti/searchList'
  // }
  // 课题列表分页查询接口
  return request({
    url,
    method: "post",
    data,
  });
};

// 获取学科大类
export const getMajorListApi = () => {
  return request({
    url: "/pubController/getMajorList",
    method: "POST",
  });
};

// 获取校区城市
export const getCityApi = (params) => {
  return request({
    url: "/productpage/courseCity",
    method: "get",
    params,
  });
};

// 课程海报接口
export const getPosterApi = (data) => {
  return request({
    url: "/pubController/getPosterEn",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
};

// 课题详情
export const getCourseDetailApi = (data) => {
  return request({
    url: "/pubController/get",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
};

// 获取课程学科附件
export function getCourseMajorAttachmentApi(data) {
  return request({
    url: "/pubController/getMajorAttachment",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

// 获取公共附件
export function getPublicAttachmentApi(data) {
  return request({
    url: "/pubController/getPublicAttachment",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

// 课程课表查询
export function getCourseScheduleApi(params, code) {
  let url = "/productpage/keti/listGroupByLessonV4";

  return request({
    url,
    method: "get",
    params,
  });
}

// 微信分享接口
export function getWxShareApi(params, code) {
  const wxShareUrl = process.env.VUE_APP_WXSHARE;
  // 地址
  const locationPath = window.location.href.split("#")[0];
  // 微信分享
  const url =
    `${wxShareUrl}/api/neo-system/thirdPart/auth/wx/config/noToken?url=` +
    encodeURIComponent(locationPath);

  return request({ url, method: "get" });
}

export const viewImagesApi = async function (id) {
  let urlPath = "";
  const {
    data: { url },
  } = await fetch(
    `${process.env.VUE_APP_BASE_API}bus/ath/resAttachment/noToken/getResAttachment?id=${id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // 根据实际情况设置请求头
      },
    }
  ).then((res) => res.json());
  urlPath = url;
  return urlPath;
};
